import React from 'react';
import { FileText, X } from 'lucide-react';

const ChangelogModal = ({ showChangelog, setShowChangelog, changelogContent }) => {
  return (
    showChangelog && (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
        <div className="bg-white w-full max-w-3xl h-[80vh] rounded-lg flex flex-col">
          <div className="p-4 border-b flex justify-between items-center">
            <div className="flex items-center gap-2">
              <FileText className="w-5 h-5 text-blue-500" />
              <h3 className="text-lg font-medium">About Smart Choice Inspections</h3>
            </div>
            <button 
              onClick={() => setShowChangelog(false)} 
              className="text-slate-500 hover:text-slate-700"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="flex-1 overflow-auto p-6">
            <div className="prose prose-slate max-w-none">
              {changelogContent.split('\n').map((line, index) => {
                // Handle headers
                if (line.startsWith('# ')) {
                  return <h1 key={index} className="text-2xl font-bold mb-4">{line.slice(2)}</h1>;
                } else if (line.startsWith('## ')) {
                  return <h2 key={index} className="text-xl font-semibold mt-6 mb-3">{line.slice(3)}</h2>;
                } else if (line.startsWith('### ')) {
                  return <h3 key={index} className="text-lg font-medium mt-4 mb-2">{line.slice(4)}</h3>;
                }
                // Handle lists
                else if (line.startsWith('- ')) {
                  // Check for bold text within the line
                  const boldPattern = /\*\*(.*?)\*\*/g;
                  const parts = line.slice(2).split(boldPattern);
                  
                  return (
                    <div key={index} className="flex items-start gap-2 my-1">
                      <span className="mt-1.5">•</span>
                      <p className="mt-0">
                        {parts.map((part, i) => 
                          i % 2 === 0 ? part : <strong key={i}>{part}</strong>
                        )}
                      </p>
                    </div>
                  );
                }
                // Handle sub-lists
                else if (line.startsWith('  - ')) {
                  return (
                    <div key={index} className="ml-6 flex items-start gap-2 my-1">
                      <span className="mt-1.5">•</span>
                      <p className="mt-0 text-sm text-slate-600">{line.slice(4)}</p>
                    </div>
                  );
                }
                // Handle empty lines
                else if (line.trim() === '') {
                  return <div key={index} className="h-4" />;
                }
                // Handle regular paragraphs
                else {
                  return <p key={index} className="my-2">{line}</p>;
                }
              })}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ChangelogModal; 